"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("../../atoms/Icon/Icon"));

var _theme = _interopRequireDefault(require("../../../theme/theme.styles"));

var _ButtonIcon = require("./ButtonIcon.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ButtonIcon = function ButtonIcon(_ref) {
  var _ref$name = _ref.name,
      name = _ref$name === void 0 ? 'close' : _ref$name,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'primary' : _ref$color,
      _ref$background = _ref.background,
      background = _ref$background === void 0 ? 'white' : _ref$background,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'xs' : _ref$size,
      _ref$service = _ref.service,
      service = _ref$service === void 0 ? false : _ref$service,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? 'occ-button-icon' : _ref$dataTestId,
      action = _ref.action;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_theme["default"], null), /*#__PURE__*/_react["default"].createElement(_ButtonIcon.Occ_ButtonIcon, {
    background: background,
    size: size,
    service: service,
    "data-test-id": dataTestId,
    onClick: action
  }, service ? /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    size: "sm",
    name: name,
    color: color
  }) : /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    size: size,
    name: name,
    color: color
  })));
};

var _default = ButtonIcon;
exports["default"] = _default;